import React, { useState, useRef, useEffect, useContext } from 'react';
import { tituloStyle } from './../styles/general';
import ListaSecciones from './listaSecciones';
import UsuarioContext from './../context/usuarioContext';

function Titulo({onSetHeight}) {
    const [seccionesVisible, setSeccionesVisible] = useState(false);
    const ref = useRef(null);
    const { usuario } = useContext(UsuarioContext)

    useEffect(() => {
        onSetHeight(ref.current.clientHeight);
    })

    function handleSeccionClick() {
        setSeccionesVisible(!seccionesVisible);
    }

    function handleSeccionItemClick() {
        setSeccionesVisible(false);
    }

    function scrollToTop(){
        window.scrollTo(0,0);
    }

    function scrollToBottom(){
        window.scrollTo(0, document.body.scrollHeight);
    }

    // const classArrow = "fa fa-sort-" + (seccionesVisible ? "asc" : "desc");
    const classArrow = "arrowLink fa fa-arrow-circle-" + (seccionesVisible ? "up" : "down");

    return (
        <div ref={ref} style={tituloStyle}>
            <table style={{width: "100%"}}>
                <tbody>
                <tr style={{}}>
                    <td style={{textAlign: "left", cursor: "pointer"}} onClick={handleSeccionClick} title={`${seccionesVisible ? "Contraer" : "Expandir"} secciones`}>
                        Nicolas Barajas Website
                        {'\u00A0'}
                        {'\u00A0'}
                        <i className={classArrow} aria-hidden="true"></i>
                    </td>
                    <td style={{textAlign: "right", fontSize: "18px"}}>
                        {usuario?.nombre ? usuario?.nombre : null}
                    </td>
                </tr>
                </tbody>
            </table>
            <hr style={{marginTop: "8px", marginBottom: "2px" }}/>
            <div style={{ display: seccionesVisible ? "block" : "none" }}>
                <ListaSecciones onItemClick={handleSeccionItemClick}/>
                <hr style={{marginTop: "8px", marginBottom: "8px" }}/>
            </div>
            <div style={{fontSize: "18px"}}>
                <i title='Ir arriba' className="arrowLink fa fa-angle-double-up" aria-hidden="true" onClick={scrollToTop}></i>
                <i style={{paddingLeft: "10px"}} title='Ir abajo' className="arrowLink fa fa-angle-double-down" aria-hidden="true" onClick={scrollToBottom}></i>
            </div>
        </div>
    );
}

export default Titulo;